import { render, staticRenderFns } from "./SimpleEmailForm.vue?vue&type=template&id=75522980&scoped=true&"
import script from "./SimpleEmailForm.vue?vue&type=script&lang=js&"
export * from "./SimpleEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleEmailForm.vue?vue&type=style&index=0&id=75522980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75522980",
  null
  
)

export default component.exports